// extracted by mini-css-extract-plugin
export default {"editEmailInput":"edit-profile-email-form_editEmailInput__13aYU","submitButton":"edit-profile-email-form_submitButton__979dk"};